function bytesToBinaryString(bytes: Uint8Array): string {
  let binary = "";
  for (const byte of bytes) {
    binary += String.fromCharCode(byte);
  }
  return binary;
}

/** Standard Base64 for UTF-8 text (e.g. Cognito OAuth state). */
export function encodeBase64Utf8(text: string): string {
  return btoa(bytesToBinaryString(new TextEncoder().encode(text)));
}

export function decodeBase64Utf8(base64: string): string {
  return new TextDecoder().decode(Uint8Array.from(atob(base64), (character) => character.charCodeAt(0)));
}

/** Base64URL without padding (e.g. PKCE, JWT segments). */
export function encodeBase64Url(bytes: Uint8Array): string {
  return btoa(bytesToBinaryString(bytes)).replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}

export function encodeRandomBase64Url(byteCount: number): string {
  return encodeBase64Url(crypto.getRandomValues(new Uint8Array(byteCount)));
}
